module.exports = __webpack_public_path__ + "static/media/support247.a151c2dc.webp";